<template>
    <div>
        <PageHeaderLayout>
            <div class="main-page-content" style="margin-top: 20px;">
                <el-row>
                    <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
                        <el-form-item label="公司名称">
                            <el-input v-model="searchCondition.corp_name" placeholder="输入公司名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchButton">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <div style="text-align: right;margin: 5px 0;">
                    <el-button v-permission:issue_add type="primary" @click="getNewChannel('add')">新增通道</el-button>
                </div>
                <el-tabs v-model="corp_type" type="card" @tab-click="handleClick" >
                    <el-tab-pane :disabled="!isAllowClick" v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
                    </el-tab-pane>
                </el-tabs>
                <ApeTable v-permission:issue_list
                    ref="apeTable"
                    :data="dataList"
                    :columns="columns"
                    :loading="loadingStaus"
                    :pagingData="pagingData"
                    highlight-current-row
                    @switchPaging="switchPaging"
                >
                <el-table-column
                    align="center"
                    label="公司主营业务">
                    <template>
                        <div>
                            人力资源、灵活用工
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="下发类型">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.type==0?'兼职':scope.row.status==1?'全职':''}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="开户状态">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.status==1?'已开户':scope.row.status==0?'未开户':''}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    align="center"
                    label="操作"
                >
                        <template slot-scope="scope">
                            <el-button v-permission:issue_configure size="mini" type="infor" @click="updateChannel(scope.row)">配置信息</el-button>
                            
                            <el-popover
                                v-permission:issue_delete
                              :ref="'el-popover-'+scope.$index"
                              placement="top"
                              width="150">
                              <p>确定要删除记录吗？</p>
                              <div style="text-align: right; margin: 0;">
                                <el-button type="text" size="mini" @click="$refs['el-popover-'+scope.$index].doClose()">取消</el-button>
                                <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                              </div>
                              <el-button slot="reference" type="danger" size="mini">删除</el-button>
                            </el-popover>
                        </template>
                    </el-table-column>
                </ApeTable>
            </div>
        </PageHeaderLayout>
        
        <el-dialog :visible.sync="is_show_form" width="60%" title="设置通道">
            
            <tz-form align="center" ref="ref_form_update" :buttonArr="formButtonArr" @buttonTap="event_formTap" :comData="formData">
                <div slot="head">
                    <el-form-item label="下发类型" prop="type">
                        <el-radio-group v-model="type" :disabled="not_select" @change="radioChange">
                          <el-radio :label="0">兼职</el-radio>
                          <el-radio :label="1">全职</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    
                    <el-form-item v-show="type==1" label="全职通道" prop="channelType">
                        <el-select :disabled="not_select" v-model="channelType" filterable placeholder="请选择" @change="changeChannelType">
                            <el-option
                                v-for="item in channelTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                
                <div slot="end">
                    <el-form-item v-if="channelType=='pingan'" label="开通权限" prop="type">
                        <el-checkbox-group v-model="auth_list">
                          <el-checkbox v-for="(item,index) in auth_list_arr" :disabled="item.disabled" :key="index" :label="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    
                    <div v-if="channelType=='pingan'" class="agree-class">
                        <el-checkbox v-model="is_agree" label="同意授权" /><a target="_blank" href="https://img.51xinlong.com/xladmin/sample/html/平安银行开放银行账户服务声明.html">{{agreeText}}</a>
                    </div>
                </div>
                
            </tz-form>
        </el-dialog>
        
        <el-dialog :visible.sync="is_show_busmod_form" width="60%" title="选择业务模式">
            
            <tz-form align="center" ref="ref_form_busmod_update" :comData="[]" :buttonArr="formButtonArr" @buttonTap="event_busmod_formTap">
                <div slot="head">
                    <!-- 只有招商的时候才显示 -->
                    <el-form-item required v-show="type==1 && channelType=='zs'" label="业务模式">
                        <el-select v-model="busmod" filterable placeholder="请选择" @change="changeBusmodType">
                            <el-option
                                v-for="item in busmodList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                
            </tz-form>
        </el-dialog>
        
        <el-dialog :visible.sync="dialog_auth_tips" center title="授权" width="60%">
            <div class="auth-tips">
                <div>
                    您已成功授权平安银行“账管+”服务，请登录平安银行企业网银或数字口袋APP进行确认！
                </div>
                <div>
                    <div><span>方案1:</span>登录平安银行企业网银 -> 现金管理 -> 开放银行 -> 签约 -> “账管 + 签约确认”进行签约确认。</div>
                   
                    <p>
                        <span>点击跳转：</span><a target="_blank" href="https://e.orangebank.com.cn/brcp/stp/cust/ebank/front/#/menus/accountManageConfirmSign?bussinessCode=131606">https://e.orangebank.com.cn/brcp/stp/cust/ebank/front/#/menus/accountManageConfirmSign?bussinessCode=131606</a>
                    </p>
                </div>
                
                <div>
                    <div>
                        <span>方案2：</span>打开数字口袋App扫描二维码，跳转到“数字口袋首页/更多/开放银行/“账管+”签约确认”进行签约确认。若为双管理员需进行复核，在数字口袋“首页/更多/交易授权/复核授权/开放银行/“账管+签约确认”进行签约复核。
                    </div>
                    
                    <div>
                        <img class="qrcode" src="https://img.51xinlong.com/xladmin/sample/image/pinganAuthQrcode.png">
                    </div>
                </div>
                
                <div>
                    <div>
                        <span>方案3：</span>请登录平安银行企业网银->现金管理-> 开放银行-> 签约-> “账管+签约确认”进行签约确认。若为双管理员需进行复核，在平安银行企业网银->现金管理->开放银行->开放银行业务复核进行签约复核。
                    </div>
                </div>
                
            </div>
            
            <div solt="footer" class="foot-btn">
                <el-button type="primary" @click="actionBtnTap">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import tzForm from "@/components/tz-form";
import pay_manage_data from './config.js';
export default {
    components: {
        tzForm,
        PageHeaderLayout,
        ApeTable,
    },
    data() {
        return {
            ...pay_manage_data,
            isAllowClick:true
        };
    },
    watch: {
    },
    methods: {
        changeBusmodType(e){
            console.log(e)
        },
        async event_formTap(e){
            console.log(e.buttonData.flag);
            switch (e.buttonData.flag) {
                case 'add':
                    var data = e.data
                    if(this.id){
                        data.id = this.id
                    }
                    if(this.type==1){
                        console.log(154);
                        console.log(this.formData);
                        this.formData.map(item => {
                            if(item.field=='uid' && item.typeData ){
                                item.typeData.map(item => {
                                    console.log(item);
                                    console.log(item.uid);
                                    if(item.val== item.uid ){
                                        data.company_id = item.company_id
                                        data.channel_account =item.channel_account
                                        data.account =item.account
                                    }
                                })
                            }
                        })
                        data.channel_type = this.channelType
                        if(this.channelType!='yinling'){
                            data = {...this.editInfo,...data}
                        }
                        if(this.channelType=='pingan'){
                            data.auth_list = this.auth_list.join(',')
                            if(!this.is_agree){
                                this.$message.warning(`请先同意${this.agreeText}`)
                                return;
                            }
                        }
                    }
                    
                    if(this.channelType == 'zs' && this.type==1){
                        this.formValueData = data
                        this.is_show_busmod_form = true
                        this.getBusmodListList(this.formValueData)
                    }else{
                        console.log(data);
                        this.createBChannel(data)
                    }
                    
                    break;
                default:
                    break;
            }
        },
        async event_busmod_formTap(){
            if(!this.busmod){
                this.$message.warning("请选择业务模式")
                return
            }
            this.formValueData.busmod = this.busmod
            this.createBChannel(this.formValueData)
        },
        // 创建
        async createBChannel(data) {
            data.corp_type = this.corp_type;
            data.type = this.type;
            let result = {}
            if(this.id){
                result = await this.$api.updatePayManageInfo(this.id,data)
            }else{
                result = await this.$api.postPayManageInfo(data)
            }
            if (result) {
                this.$message.success("保存成功")
                this.showAndHideForm()
                this.id = '';
                this.busmod = '';
                if(this.channelType == 'pingan'){
                    this.dialog_auth_tips = true
                }
                if(this.channelType == 'zs'){
                    this.is_show_busmod_form = false
                }
                this.formData.map(item => {
                    item.val = ''
                })
                this.initForm()
                this.init('search')
            }
        },
        async updateChannel(e){
            this.initForm()
            this.id = e.id;
            let {
                corp_id,
                corp_type,
                uid,
                company_id,
                account,
                channel_type,
                channel_account,
                id,
                type,
                is_sign,
                merchant_no,
                acct_no,
                acct_name,
                app_id,
                mobile,
                auth_list,
                pf_public_key,
                private_key,
                des_key,
                busmod,
                bbknbr
            } = e
            let obj = {
                mobile,
                app_id,
                corp_id,
                corp_type,
                uid,
                company_id,
                account,
                channel_type,
                channel_account,
                id,
                type,
                is_sign,
                merchant_no,
                acct_no,
                acct_name,
                pf_public_key,
                private_key,
                des_key,
                busmod,
                bbknbr
            }
            
            if(channel_type){
                this.channelType = channel_type
            }
            if(busmod){
                this.busmod = busmod
            }
            this.type = type
            this.not_select = true
            if(this.type==0){
                this.formData = this.formData_0
            }else{
                if(this.channelType == 'yinling'){
                    this.formData = this.formData_1
                    this.getAllChannelList()
                }else if(this.channelType == 'xinwang'){
                    this.formData = this.formData_2
                    this.editInfo = {
                        app_id,
                        uid,
                        account,
                        channel_account,
                        company_id
                    }
                }else if(this.channelType == 'pingan'){
                    if(auth_list){
                        var auth_list_1 = []
                        console.log(auth_list)
                        if(auth_list.split(',').includes('4047') && auth_list.split(',').includes('4048')){
                            auth_list.split(',').map(item=>{
                                if(item!='4047' && item!='4048'){
                                    auth_list_1.push(item)
                                }
                            })
                            auth_list_1.push('4047,4048')
                        }else{
                            auth_list_1 = auth_list.split(',')
                        }
                        this.auth_list = auth_list_1
                    }
                    console.log(auth_list_1,auth_list_1.indexOf('4047'))
                    this.formData = this.formData_3
                    this.editInfo = {
                        uid,
                        account,
                        channel_account,
                        company_id,
                    }
                }else if(this.channelType == 'zs'){
                    this.formData = this.formData_zs
                    this.editInfo = {
                        uid,
                        account,
                        channel_account,
                        company_id,
                    }
                    this.getBusmodListList(obj)
                } else if(this.channelType === 'pinganpay') {
                    this.formData = this.formData_4
                    this.editInfo = {
                        uid,
                        account,
                        channel_account,
                        company_id,
                        is_sign,
                        corp_id
                    }
                }
            }
            this.formData.map(item => {
                item.val = obj[item.field]
            })
            
            this.showAndHideForm()
        },
        async getNewChannel(){
            this.initForm()
            this.showAndHideForm()
        },
        
        async initForm(){
            console.log();
            // if(this.type === 0) {
            //     this.formData.map(item => {
            //     if(item.field=='is_sign'){
            //         item.val = 1
            //     }else{
            //         item.val = ''
            //     }
            // })
            // }
            this.formData.map(item => {
                if(item.field=='is_sign' && this.type === 0){
                    item.val = 1
                } else if(item.field=='is_sign' && this.type === 1)
                   { item.val = 0
                }else{
                    item.val = ''
                }
            })
            this.id = '';
            this.type = 0;
            this.channelType = 'yinling';
            this.channel_account = '';
            this.editInfo = {};
            this.auth_list = ['4001'];
            this.formData = this.formData_0
            this.not_select = false
            // if(this.corp_type==2){
            //     this.not_select = true
            // }
        },
        async showAndHideForm(){
            this.is_show_form = !this.is_show_form
        },
        async allCompanyList() {
            let result = [];
            let data = {
                page_size:9999,
                current_page:1,
                status:1
            };
            if(this.corp_type==1){
                result = await this.$api.getPaihuoHumanResources(data)
            }else if(this.corp_type==2){
                result = await this.$api.getPaihuoEmploymentResource(data)
            }else{
                return;
            }
          let arr = []
          
          result.items.map(item => {
            let obj = {
                label: item.company_name,
                val: item.id
            }
            arr.push(obj)
          })
          this.formData[0].typeData = arr
          this.formData_0[0].typeData = arr
          this.formData_1[0].typeData = arr
          this.formData_2[0].typeData = arr
          this.formData_3[0].typeData = arr
          this.formData_4[0].typeData = arr
          this.formData_zs[0].typeData = arr
        },
        async getBusmodListList(param) {
            let result = [];
            this.busmodList = [];
            let {
                merchant_no,
                private_key,
                pf_public_key,
                des_key
            } = param;
            let data = {
                merchant_no,
                private_key,
                pf_public_key,
                des_key
            }
            
            result = await this.$api.getBusmodListList(data)
          
            let arr = []
          let is_has_select_type = false
          result.map(item => {
              if(!is_has_select_type && item.busmod==this.busmod){
                  is_has_select_type = true
              }
            let obj = {
                label: item.name,
                id: item.busmod,
            }
            arr.push(obj)
          })
          if(!is_has_select_type){
              this.busmod = ''
          }
          this.busmodList = arr
        },
        async getAllChannelList() {
            let result = [];
            let data = {
                page_size:9999,
                current_page:1,
                status:1,
                corp_type:this.corp_type
            };
            
            result = await this.$api.getPayMangeChannelList(data)
          
            let arr = []
          
          result.map(item => {
            let obj = {
                label: item.channel_name,
                val: item.uid,
                uid:item.uid,
                company_id:item.company_id,
                account:item.account,
                channel_account:item.channel_account,
            }
            arr.push(obj)
          })
          this.formData_1[1].typeData = arr
        },
        // 重置分页
        async resetPage() {
            this.$refs.apeTable.currentPage = 1
        },
        // 切换页码操作
        async switchPaging() {
            this.init();
        },
        // 搜索
        searchButton() {
            this.resetPage()
            console.log(this.searchCondition,99999)
            this.init('search')
        },
        //获取列表
        async init(type) {
            this.loadingStaus=true
            let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
            let searchCondition = this.handleSearchCondition()
            Object.assign(searchCondition,pagingInfo)
            this.dataList = []
            let { data, pages} = await this.$api.getPayManageList(searchCondition)
            this.$nextTick(() => {
                this.dataList=data
            })
            this.pagingData.total = pages.total
            this.offset = pages.offset
            this.loadingStaus=false
        },
        // 处理搜索条件
        handleSearchCondition() {
            let condition = {}
            if (this.searchCondition.corp_name) {
                condition.corp_name = this.searchCondition.corp_name
            }
            
            if(this.corp_type){
                condition.corp_type = this.corp_type
            }
            
            return condition
        },
        //点击tab切换
        async handleClick(tab) {
            this.searchCondition={status:'',corp_name:'',time:''};
            this.corp_type = tab.name;
            this.resetPage()
            this.isAllowClick = false
            await this.allCompanyList()
            this.init()
            this.isAllowClick = true
        },
        async updateStatus(project_status){
            this.corp_type = project_status;
        },
        radioChange(e){
            if(e==1){
                this.formData = this.formData_1
                this.getAllChannelList()
            }else{
                this.formData = this.formData_0
            }
            
            this.channelType = 'yinling'
            this.auth_list = ['4001'];
            this.editInfo = {}
            
        },
        
        // 删除商户
        async deleteButton(id) {
          let result = await this.$api.deleteOpenApiConfig(id)
          if(result) {
            this.$message.success('删除成功')
            this.init()
          }
        },
        
        changeChannelType(e){
            console.log(e)
            if(e=='yinling'){
                this.formData = this.formData_1
                this.getAllChannelList()
            }else if(e=='xinwang'){
                this.formData = this.formData_2
            }else if(e=='pingan'){
                this.formData = this.formData_3
            }else if(e=='zs'){
                this.formData = this.formData_zs
            } else if ( e=== 'pinganpay') {
                this.formData = this.formData_4
                console.log(this.formData);
                // this.formData[5].typeData = [{label:'否',val:0}]
            }
        },
        
        actionBtnTap(){
            this.dialog_auth_tips = false
        },
        
    },
    mounted() {
        this.resetPage()
        if(this.$route.query.type&&this.$route.query.type!='undefined') {
            this.updateStatus(this.$route.query.type)
        }
        this.init();
        this.allCompanyList()
        this.formData = this.formData_0
    },
};
</script>

<style lang="scss" scoped>
    .agree-class{
        margin: 20px;
    }
    .foot-btn,.agree-class{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .auth-tips{
        text-align: left;
        &>div:first-child{
            margin-bottom: 30px;
            text-align: center;
            font-size: 16px;
            font-weight: 600;
            color: #333;
            line-height: 1.6;
        }
        &> div {
            margin: 10px 0;
            text-indent: 2em;
            
            .qrcode{
                margin: auto;
                display: block;
                margin-top: 10px;
                width: 100px;
                height: 100px;
            }
            
            span{
                font-size: 14px;
                font-weight: 600;
                color: #333;
                line-height: 1.6;
            }
        }
    }
</style>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px
.operation-btn
  margin: 0 20px
.el-button + .el-button
  margin-left: 0

el-radio-group{
 display :flex;    
}

</style>